<template>
  <div class="box-border flex pt-7 px-5 space-x-5">
    <div class="w-full flex flex-col">
      <div class="flex items-center space-x-6 mb-4">
        <router-link
          v-for="country in countries"
          :key="country.code"
          :to="{ name: 'articles-country', params: { country: country.code } }"
          class="nav-item m-0 text-2xl font-bold text-black cursor-pointer"
        >
          {{ country.name }}
        </router-link>
      </div>

      <router-view
        v-if="countries.length && isFetchedBlocks && isFetchedPages"
        :key="activeRouteCountry"
      />
    </div>
  </div>
</template>

<script>
import { computed, onUpdated } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useCountries } from '@/composables/countries'
import { useArticles } from './composables/articles'
import { useBlocks } from './composables/blocks'
import { usePages } from './composables/pages'

export default {
  setup () {
    const route = useRoute()
    const router = useRouter()

    const { fetchArticles } = useArticles()
    fetchArticles()

    const { fetchBlocks } = useBlocks({ route, router })
    const { isFetchedBlocks } = fetchBlocks()

    const { fetchPages } = usePages({ route, router })
    const { isFetchedPages } = fetchPages()

    const { countries } = useCountries()
    const activeRouteCountry = computed(() => route.params.country)

    onUpdated(() => {
      if (route.name !== 'articles') return

      router.replace({
        name: 'articles-country',
        params: {
          country: countries.value[0].code
        }
      })
    })

    return {
      isFetchedBlocks,
      isFetchedPages,
      countries,
      activeRouteCountry
    }
  }
}
</script>

<style lang="postcss" scoped>
.nav-item:not(.router-link-active) {
  @apply opacity-30;
}
</style>

<style lang="postcss">
.outline-solid-2 {
  outline: solid 2px transparent;
}

.block.sortable-ghost,
.item.sortable-ghost {
  @apply opacity-20;
}
</style>
